import { TranslationDataType } from 'resources/translation';

import { getValidationConstructor } from './validationConstructor';

export const getPhoneValidation = (t: TranslationDataType) => ({
  standart: getValidationConstructor(t, /^(\+)[0-9+]*\s*$/, 'phone_validation'),
});
